__turbopack_context__.v({
  "button": "sdUDNa_button",
  "item": "sdUDNa_item",
  "itemText": "sdUDNa_itemText",
  "proposalDetails": "sdUDNa_proposalDetails",
  "title": "sdUDNa_title",
});
